import classNames from "classnames";
import React from "react";
import { intl } from "../i18n/TypedIntl";
import styles from "./collapsibleContainer.css";

interface Props {
  isTextCollapsed?: boolean;
  text: string;
}

interface State {
  textCollapsed: boolean;
}

export class CollapsibleContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      textCollapsed: this.props.isTextCollapsed ? this.props.isTextCollapsed : false
    };
  }

  handleToggleExpand = () => this.setState({ textCollapsed: !this.state.textCollapsed });

  render() {
    return (
      <div
        className={classNames(styles.collapsible, { [styles.collapsed]: this.state.textCollapsed })}
      >
        {this.state.textCollapsed && (
          <div className={styles.ellipsis}>
            ...{" "}
            <span className={styles["expand-collapse-link"]} onClick={this.handleToggleExpand}>
              {intl.formatMessage("showMore")}
            </span>
          </div>
        )}
        {this.props.text}
        {!this.state.textCollapsed && (
          <span
            className={classNames([styles["expand-collapse-link"], styles["show-less"]])}
            onClick={this.handleToggleExpand}
          >
            {intl.formatMessage("showLess")}
          </span>
        )}
      </div>
    );
  }
}
